<!-- 模板部分 -->
<template>
    <div class="notesDeliver">
        <Modal v-model = "showFlag" width = "400" :transfer = 'closable' :footerHide = 'footerHide' :mask-closable = "mask_closable" :closable = "closable">
            <div class = 'bodys'>
                <div class="headers">
                    请选择工作岗位所在城市
                </div>
                <div class="contents" v-show = 'linkSikp'>
                    <CheckboxGroup v-model = 'addressChoosed'>
                        <div class="details" v-for = 'item in addressInfo' :key = 'item.id'>
                            <Checkbox class = 'clearfloat' :label = 'item.id'>
                                <span class = 'address pull-left'>{{item.formatted_address}}{{!item.job_address ? '' : item.job_address}}</span>
                            </Checkbox>
                        </div>
                    </CheckboxGroup>
                    <div class="marks">
                        <div class="details">
                            <Checkbox v-model="sendAttachment">
                                <span class = 'address pull-left'>同时投递简历附件</span>
                            </Checkbox>
                        </div>
                    </div>
                    <div class="points1" v-show = 'notesPointShowFlag'>
                        <span>您未上传简历，</span><span @click = '_skipFileNotes'>去上传 ></span>
                    </div>
                </div>
                <div class="contents" v-show = '!linkSikp'>
                    <div class="points">
                        本招聘信息来源于其他网站，朝聘网仅为您提供信息展示等服务，您所获得的招聘信息均以对应网站为准。
                    </div>
                </div>
                <div class="footers clearfloat">
                    <div class = 'left pull-left' @click = '_close'>
                        取消
                    </div>
                    <div class = 'right pull-right'>
                        <a :href = 'website' @click = '_close' target = "_blank" v-if = '!linkSikp'>确定</a>
                        <a href = "javascript:void(0);" @click = '_submit' v-if = 'linkSikp'>确定</a>
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<!-- 表示样式部分 -->
<style lang="less" scoped>
    .notesDeliver /deep/ .ivu-modal-body {
        padding: 0px !important;
    }
    .notesDeliver /deep/ .ivu-radio-group {
        width: 100% !important;
    }
    .notesDeliver /deep/ .ivu-modal-content {
        background-color: transparent !important;
    }
    .notesDeliver /deep/ .ivu-radio-wrapper {
        width: 100% !important;
        position: relative;
    }
    .notesDeliver /deep/ .ivu-checkbox-wrapper {
        width: 100% !important;
        position: relative;
    }
    .notesDeliver /deep/ .ivu-radio {
        float: right;
        position: absolute;
        right: 0px;
        top: 50%;
        transform: translateY(-50%);
    }
    .notesDeliver /deep/ .ivu-checkbox {
        float: right;
        position: absolute;
        right: 0px;
        top: 50%;
        transform: translateY(-50%);
    }
    .notesDeliver /deep/ .ivu-checkbox-checked .ivu-checkbox-inner {
        border-color: #10c9a5 !important;
        background-color: #10c9a5 !important;
    }
    .notesDeliver /deep/ .ivu-radio-checked .ivu-radio-inner {
        border-color: #10c9a5 !important;
    }
    .notesDeliver /deep/ .ivu-radio-inner:after {
        background-color: #10c9a5 !important;
    }
    .notesDeliver {
        .bodys {
            width: 400px;
            min-height: 326px;
            box-shadow:0px 2px 16px 0px rgba(188,188,203,0.5);
            border-radius:8px 8px 6px 6px;
            background: #ffffff;
            .headers {
                text-align: center;
                width:100%;
                height:38px;
                line-height: 38px;
                background:rgba(16,201,165,1);
                border-radius:8px 8px 1px 1px;
                color: #FFFFFF;
                font-size: 14px;
                font-family:PingFangSC-Medium,PingFang SC;
            }
            .contents {
                padding-top: 8px;
                min-height: 250px;
                .active {
                    color: #10C9A5 !important;
                }
                .details {
                    width:355px;
                    margin: 0px auto;
                    padding: 10px 10px 10px 17px;
                    box-sizing: border-box;
                    background:rgba(245,249,255,1);
                    border-radius:2px;
                    color: #9C9AAC;
                    font-size: 12px;
                    font-family:PingFangSC-Medium,PingFang SC;
                    margin-bottom: 10px;
                    .address {
                        display: inline-block;
                        vertical-align: middle;
                        max-width: 275px;
                        white-space: normal;
                    }
                }
                .points1 {
                    width: 355px;
                    margin: 0px auto;
                    padding: 0px 10px 10px 17px;
                    span:nth-child(1) {
                        font-size: 13px;
                        color: #666;
                    }
                    span:nth-child(2) {
                        cursor: pointer;
                        font-size: 13px;
                        color: #00b2b7;
                    }
                }
                .points {
                    padding: 30px 10px;
                    text-indent: 25px;
                    color: #666;
                    font-size: 16px;
                }
                .marks {
                    .details {
                        background: #ffffff;
                        margin-bottom: 0px;
                    }
                }
            }
            .footers {
                width: 100%;
                height: 40px;
                line-height: 40px;
                border-top: 1px solid #F5F5F9;
                .left {
                    width: 49%;
                    height: 100%;
                    text-align: center;
                    color: #999999;
                    font-size: 14px;
                    font-family:PingFangSC-Medium,PingFang SC;
                    cursor: pointer;
                    border-right: 1px solid #F5F5F9;
                }
                .right {
                    width: 49%;
                    height: 100%;
                    text-align: center;
                    color: #4C85F4;
                    font-size: 14px;
                    font-family:PingFangSC-Medium,PingFang SC;
                    cursor: pointer;
                }
            }
        }
    }
</style>

<!-- 表示js动作部分 -->
<script>

    // 导入axios模块
    import {
        GetCitysByJob,
        JobApplyD
    } from '@/api/request/jobService';

    // 导出模块
    export default {

        // 名称
        name: 'cu-notesdeliverresume',

        // 数据
        data: function() {
            return {

                // 不显示底部
                footerHide: true,
                // 不显示关闭按钮
                closable: false,
                // 点击遮罩层不允许关闭
                mask_closable: false,
                // 是否默认允许发送简历 true 表示1 false表示0
                sendAttachment: true,
                // 表示临时的职位id
                positionIdTemp: '',
                // 表示地址列表
                addressInfo: [],
                // 表示默认选中的地址
                addressChoosed: [],
                // 表示是否上传简历
                notesPointShowFlag: false
            }
        },

        // 表示参数
        props: {

            // 表示职位id
            positionId: {
                type: String,
                default: ''
            },

            // 表示显隐
            showFlag: {
                type: Boolean,
                default: false
            },

            // 判断是否跳转链接 true 选择地址 false 跳转链接
            linkSikp: {
                type: Boolean,
                default: true
            },
            
            // 表示需要跳转url
            website: {
                type: String,
                default: ''
            }
        },

        // 监听
        watch: {

            // 监听打开弹框
            showFlag: function(val) {

                // 清空提示设置
                if (!val) this.notesPointShowFlag = false;

                // 跳转链接 || 判断是否打开弹框 || 是否已经加载数据
                if (!this.linkSikp || !val || (this.positionId === this.positionIdTemp && this.addressInfo.length > 0)) return false;

                this.positionIdTemp = this.positionId;
                this._queryInfo();
            }
        },

        // 方法
        methods: {

            /**
             * @author lihh
             * @description 进行数据查询
             */
            _queryInfo: function() {

                // 查询地址信息
                GetCitysByJob(this.positionId).then(res => {

                    // 判断是否查询成功
                    if (res.code !== '200') {

                        res.msg == 'Token已失效' ? new Error(res.msg) : this.$Message.error(res.msg);
                        return false;
                    }

                    this.addressInfo = Array.isArray(res.data) ? res.data : [];
                });
            },

            /**
             * @author lihh
             * @description 跳转简历附件上传
             */
            _skipFileNotes: function() {

                this.$store.dispatch('_personalCenterNav', 'fileNotes');
                this.$router.push({path: '/fileNotes'});
            },

            /**
             * @author lihh
             * @description 点击确定按钮 进行投递
             */
            _submit: function() {

                if (!this.addressChoosed.length) {
                    this.$Message.error("请选择投递职位工作地址")
                    return
                }

                // 判断是否跳转链接
                if (!this.linkSikp) return false;

                // 进行投递 设置参数
                const param = {
                    // 城市id
                    deliveryCityId: String(this.addressChoosed),
                    // 是否默认发送简历
                    sendAttachment: this.sendAttachment ? '1' : '0'
                }
                JobApplyD(param).then(res => {

                    // 判断是否请求成功
                    if (res.code !== '200') {

                        // 判断是否未设置简历
                        if (res.code === '20055') {

                            this.notesPointShowFlag = true;
                            return false;
                        }
                        res.msg == 'Token已失效' ? new Error(res.msg) : this.$Message.error(res.msg);
                        return false;
                    }

                    // 简历投递成功
                    this.$Message.success('简历投递成功，请静候佳音!');
                    this.$emit('_close', true);
                });
            },

            /**
             * @author lihh
             * @description 关闭弹框
             */
            _close: function() {

                // 进行弹框关闭
                this.$emit('_close', false);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/packages/NotesDeliverResume/CuNotesDeliver/Cu-NotesDeliverResume.vue